import { gql } from '@apollo/client'

export const UPLOAD_FILE = gql`
  mutation UploadFile($input: UploadFileInput!) {
    uploadFile(input: $input) {
      clientMutationId
      file {
        id
        name
        mimeType
        downloadUrl
      }
    }
  }
`

export const DELETE_FILES = gql`
  mutation DeleteFiles($input: DeleteFilesInput!) {
    deleteFiles(input: $input) {
      clientMutationId
    }
  }
`

export const UPDATE_RESOURCE = gql`
  mutation UpdateResourceMutation($input: UpdateResourceInput!) {
    updateResource(input: $input) {
      clientMutationId
      resource {
        id
        name
        description
        type
        timeSlotLength
        owner {
          id
          email
          name
        }
        holderPublic
        bookingUnitPrice
        bookingConfirmationRequired
        bookingConfirmationByHolderAllowed
        bookingConfirmationViaLockConnectionAllowed
        bookingConfirmationStartOffset
        bookingConfirmationEndOffset
        settings {
          bookingCancellationEndOffset
          bookingAvailabilitySchedule {
            isValid
            vEvent
          }
          defaultName
          defaultDescription
          translations {
            language {
              id
              name
            }
            values {
              name
              description
            }
          }
        }
        minTimeSlotsPerBooking
        maxTimeSlotsPerBooking
        minTimeSlotsPerSharing
        maxTimeSlotsPerSharing
        maxTimeSlotsBackwardForBooking
        maxTimeSlotsForwardForBooking
        maxTimeSlotsBackwardForSharing
        maxTimeSlotsForwardForSharing
        multipleBookingsOfSameTypeAllowed
        minBookingStart
        maxBookingEnd
        minSharingStart
        maxSharingEnd
        lockAccessStartOffsetForBooking
        lockAccessEndOffsetForBooking
        timezone
        spaceplanPoint {
          x
          y
        }
        featuredImage {
          id
          databaseId
          name
          mimeType
          downloadUrl
        }
        attachments {
          nodes {
            id
            name
            mimeType
            downloadUrl
          }
        }
        location {
          id
          name
          spaceplanUrl
        }
        accessZone {
          id
          name
          delegatedAccount {
            provider
            reconnectRequired
          }
        }
        externalCalendarIntegration {
          externalCalendar {
            id
            name
            delegatedAccountProvider
          }
          syncMode
        }
        viewerCanDisconnectExternalCalendar
        viewerCanConnectExternalCalendar
      }
    }
  }
`
